const formatUTCDate = (value) => {
  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return "";

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
  { field: "tempProcesoEntrada", headerName: "Temp Proceso Entrada", minWidth: 180, flex: 1 },
  { field: "tempProcesoSalida", headerName: "Temp Proceso Salida", minWidth: 180, flex: 1 },
  { field: "condicionActualEquipo", headerName: "Condición Actual del Equipo", minWidth: 200, flex: 1 },
  { field: "modulo1Status", headerName: "Módulo 1 Status", minWidth: 150, flex: 1 },
  { field: "modulo2Status", headerName: "Módulo 2 Status", minWidth: 150, flex: 1 },
  { field: "modulo3Status", headerName: "Módulo 3 Status", minWidth: 150, flex: 1 },
  { field: "modulo4Status", headerName: "Módulo 4 Status", minWidth: 150, flex: 1 },
  { field: "modulo5Status", headerName: "Módulo 5 Status", minWidth: 150, flex: 1 },
  { field: "modulo6Status", headerName: "Módulo 6 Status", minWidth: 150, flex: 1 },
  { field: "modulo7Status", headerName: "Módulo 7 Status", minWidth: 150, flex: 1 },
  { field: "modulo8Status", headerName: "Módulo 8 Status", minWidth: 150, flex: 1 },
  { field: "modulo9Status", headerName: "Módulo 9 Status", minWidth: 150, flex: 1 },
  { field: "modulo10Status", headerName: "Módulo 10 Status", minWidth: 150, flex: 1 },
  { field: "m1CondicionCompresor", headerName: "M1 Condición Compresor", minWidth: 200, flex: 1 },
  { field: "m1CargaCompresor", headerName: "M1 % de Carga Compresor", minWidth: 200, flex: 1 },
  { field: "m1TempEvapSalida", headerName: "M1 Temp Evap Salida", minWidth: 180, flex: 1 },
  { field: "m1TempDescarga", headerName: "M1 Temp Descarga", minWidth: 180, flex: 1 },
  { field: "m1PresionSuccion", headerName: "M1 Presión Succión", minWidth: 200, flex: 1 },
  { field: "m1PresionDescarga", headerName: "M1 Presión Descarga", minWidth: 200, flex: 1 },
  { field: "m1IDE", headerName: "M1 IDE", minWidth: 150, flex: 1 },
  { field: "m2CondicionCompresor", headerName: "M2 Condición Compresor", minWidth: 200, flex: 1 },
  { field: "m2CargaCompresor", headerName: "M2 % de Carga Compresor", minWidth: 200, flex: 1 },
  { field: "m2TempEvapSalida", headerName: "M2 Temp Evap Salida", minWidth: 180, flex: 1 },
  { field: "m2TempDescarga", headerName: "M2 Temp Descarga", minWidth: 180, flex: 1 },
  { field: "m2PresionSuccion", headerName: "M2 Presión Succión", minWidth: 200, flex: 1 },
  { field: "m2PresionDescarga", headerName: "M2 Presión Descarga", minWidth: 200, flex: 1 },
  { field: "m2IDE", headerName: "M2 IDE", minWidth: 150, flex: 1 },
  { field: "m3CondicionCompresor", headerName: "M3 Condición Compresor", minWidth: 200, flex: 1 },
  { field: "m3CargaCompresor", headerName: "M3 % de Carga Compresor", minWidth: 200, flex: 1 },
  { field: "m3TempEvapSalida", headerName: "M3 Temp Evap Salida", minWidth: 180, flex: 1 },
  { field: "m3TempDescarga", headerName: "M3 Temp Descarga", minWidth: 180, flex: 1 },
  { field: "m3PresionSuccion", headerName: "M3 Presión Succión", minWidth: 200, flex: 1 },
  { field: "m3PresionDescarga", headerName: "M3 Presión Descarga", minWidth: 200, flex: 1 },
  { field: "m3IDE", headerName: "M3 IDE", minWidth: 150, flex: 1 },
  { field: "m4CondicionCompresor", headerName: "M4 Condición Compresor", minWidth: 200, flex: 1 },
  { field: "m4CargaCompresor", headerName: "M4 % de Carga Compresor", minWidth: 200, flex: 1 },
  { field: "m4TempEvapSalida", headerName: "M4 Temp Evap Salida", minWidth: 180, flex: 1 },
  { field: "m4TempDescarga", headerName: "M4 Temp Descarga", minWidth: 180, flex: 1 },
  { field: "m4PresionSuccion", headerName: "M4 Presión Succión", minWidth: 200, flex: 1 },
  { field: "m4PresionDescarga", headerName: "M4 Presión Descarga", minWidth: 200, flex: 1 },
  { field: "m4IDE", headerName: "M4 IDE", minWidth: 150, flex: 1 },
  { field: "m5CondicionCompresor", headerName: "M5 Condición Compresor", minWidth: 200, flex: 1 },
  { field: "m5CargaCompresor", headerName: "M5 % de Carga Compresor", minWidth: 200, flex: 1 },
  { field: "m5TempEvapSalida", headerName: "M5 Temp Evap Salida", minWidth: 180, flex: 1 },
  { field: "m5TempDescarga", headerName: "M5 Temp Descarga", minWidth: 180, flex: 1 },
  { field: "m5PresionSuccion", headerName: "M5 Presión Succión", minWidth: 200, flex: 1 },
  { field: "m5PresionDescarga", headerName: "M5 Presión Descarga", minWidth: 200, flex: 1 },
  { field: "m5IDE", headerName: "M5 IDE", minWidth: 150, flex: 1 },
  { field: "m6CondicionCompresor", headerName: "M6 Condición Compresor", minWidth: 200, flex: 1 },
  { field: "m6CargaCompresor", headerName: "M6 % de Carga Compresor", minWidth: 200, flex: 1 },
  { field: "m6TempEvapSalida", headerName: "M6 Temp Evap Salida", minWidth: 180, flex: 1 },
  { field: "m6TempDescarga", headerName: "M6 Temp Descarga", minWidth: 180, flex: 1 },
  { field: "m6PresionSuccion", headerName: "M6 Presión Succión", minWidth: 200, flex: 1 },
  { field: "m6PresionDescarga", headerName: "M6 Presión Descarga", minWidth: 200, flex: 1 },
  { field: "m6IDE", headerName: "M6 IDE", minWidth: 150, flex: 1 },
  { field: "m7CondicionCompresor", headerName: "M7 Condición Compresor", minWidth: 200, flex: 1 },
  { field: "m7CargaCompresor", headerName: "M7 % de Carga Compresor", minWidth: 200, flex: 1 },
  { field: "m7TempEvapSalida", headerName: "M7 Temp Evap Salida", minWidth: 180, flex: 1 },
  { field: "m7TempDescarga", headerName: "M7 Temp Descarga", minWidth: 180, flex: 1 },
  { field: "m7PresionSuccion", headerName: "M7 Presión Succión", minWidth: 200, flex: 1 },
  { field: "m7PresionDescarga", headerName: "M7 Presión Descarga", minWidth: 200, flex: 1 },
  { field: "m7IDE", headerName: "M7 IDE", minWidth: 150, flex: 1 },
  { field: "m8CondicionCompresor", headerName: "M8 Condición Compresor", minWidth: 200, flex: 1 },
  { field: "m8CargaCompresor", headerName: "M8 % de Carga Compresor", minWidth: 200, flex: 1 },
  { field: "m8TempEvapSalida", headerName: "M8 Temp Evap Salida", minWidth: 180, flex: 1 },
  { field: "m8TempDescarga", headerName: "M8 Temp Descarga", minWidth: 180, flex: 1 },
  { field: "m8PresionSuccion", headerName: "M8 Presión Succión", minWidth: 200, flex: 1 },
  { field: "m8PresionDescarga", headerName: "M8 Presión Descarga", minWidth: 200, flex: 1 },
  { field: "m8IDE", headerName: "M8 IDE", minWidth: 150, flex: 1 },
  { field: "m9CondicionCompresor", headerName: "M9 Condición Compresor", minWidth: 200, flex: 1 },
  { field: "m9CargaCompresor", headerName: "M9 % de Carga Compresor", minWidth: 200, flex: 1 },
  { field: "m9TempEvapSalida", headerName: "M9 Temp Evap Salida", minWidth: 180, flex: 1 },
  { field: "m9TempDescarga", headerName: "M9 Temp Descarga", minWidth: 180, flex: 1 },
  { field: "m9PresionSuccion", headerName: "M9 Presión Succión", minWidth: 200, flex: 1 },
  { field: "m9PresionDescarga", headerName: "M9 Presión Descarga", minWidth: 200, flex: 1 },
  { field: "m9IDE", headerName: "M9 IDE", minWidth: 150, flex: 1 },
  { field: "m10CondicionCompresor", headerName: "M10 Condición Compresor", minWidth: 200, flex: 1 },
  { field: "m10CargaCompresor", headerName: "M10 % de Carga Compresor", minWidth: 200, flex: 1 },
  { field: "m10TempEvapSalida", headerName: "M10 Temp Evap Salida", minWidth: 180, flex: 1 },
  { field: "m10TempDescarga", headerName: "M10 Temp Descarga", minWidth: 180, flex: 1 },
  { field: "m10PresionSuccion", headerName: "M10 Presión Succión", minWidth: 200, flex: 1 },
  { field: "m10PresionDescarga", headerName: "M10 Presión Descarga", minWidth: 200, flex: 1 },
  { field: "m10IDE", headerName: "M10 IDE", minWidth: 150, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempProcesoEntrada: row["Temp Proceso Entrada"],
  tempProcesoSalida: row["Temp Proceso Salida"],
  condicionActualEquipo: row["Condicion Actual del Equipo"],
  modulo1Status: row["Módulo 1 Status"],
  modulo2Status: row["Módulo 2 Status"],
  modulo3Status: row["Módulo 3 Status"],
  modulo4Status: row["Módulo 4 Status"],
  modulo5Status: row["Módulo 5 Status"],
  modulo6Status: row["Módulo 6 Status"],
  modulo7Status: row["Módulo 7 Status"],
  modulo8Status: row["Módulo 8 Status"],
  modulo9Status: row["Módulo 9 Status"],
  modulo10Status: row["Módulo 10 Status"],
  m1CondicionCompresor: row["M1 Condición Actual del Compresor"],
  m1CargaCompresor: row["M1 % de Carga Compresor"],
  m1TempEvapSalida: row["M1 Temp Evap Salida"],
  m1TempDescarga: row["M1 Temp Descarga"],
  m1PresionSuccion: row["M1 Presión Succión"],
  m1PresionDescarga: row["M1 Presión Descarga"],
  m1IDE: row["IDE M1"],
  m2CondicionCompresor: row["M2 Condición Actual del Compresor"],
  m2CargaCompresor: row["M2 % de Carga Compresor"],
  m2TempEvapSalida: row["M2 Temp Evap Salida"],
  m2TempDescarga: row["M2 Temp Descarga"],
  m2PresionSuccion: row["M2 Presión Succión"],
  m2PresionDescarga: row["M2 Presión Descarga"],
  m2IDE: row["IDE M2"],
  m3CondicionCompresor: row["M3 Condición Actual del Compresor"],
  m3CargaCompresor: row["M3 % de Carga Compresor"],
  m3TempEvapSalida: row["M3 Temp Evap Salida"],
  m3TempDescarga: row["M3 Temp Descarga"],
  m3PresionSuccion: row["M3 Presión Succión"],
  m3PresionDescarga: row["M3 Presión Descarga"],
  m3IDE: row["IDE M3"],
  m4CondicionCompresor: row["M4 Condición Actual del Compresor"],
  m4CargaCompresor: row["M4 % de Carga Compresor"],
  m4TempEvapSalida: row["M4 Temp Evap Salida"],
  m4TempDescarga: row["M4 Temp Descarga"],
  m4PresionSuccion: row["M4 Presión Succión"],
  m4PresionDescarga: row["M4 Presión Descarga"],
  m4IDE: row["IDE M4"],
  m5CondicionCompresor: row["M5 Condición Actual del Compresor"],
  m5CargaCompresor: row["M5 % de Carga Compresor"],
  m5TempEvapSalida: row["M5 Temp Evap Salida"],
  m5TempDescarga: row["M5 Temp Descarga"],
  m5PresionSuccion: row["M5 Presión Succión"],
  m5PresionDescarga: row["M5 Presión Descarga"],
  m5IDE: row["IDE M5"],
  m6CondicionCompresor: row["M6 Condición Actual del Compresor"],
  m6CargaCompresor: row["M6 % de Carga Compresor"],
  m6TempEvapSalida: row["M6 Temp Evap Salida"],
  m6TempDescarga: row["M6 Temp Descarga"],
  m6PresionSuccion: row["M6 Presión Succión"],
  m6PresionDescarga: row["M6 Presión Descarga"],
  m6IDE: row["IDE M6"],
  m7CondicionCompresor: row["M7 Condición Actual del Compresor"],
  m7CargaCompresor: row["M7 % de Carga Compresor"],
  m7TempEvapSalida: row["M7 Temp Evap Salida"],
  m7TempDescarga: row["M7 Temp Descarga"],
  m7PresionSuccion: row["M7 Presión Succión"],
  m7PresionDescarga: row["M7 Presión Descarga"],
  m7IDE: row["IDE M7"],
  m8CondicionCompresor: row["M8 Condición Actual del Compresor"],
  m8CargaCompresor: row["M8 % de Carga Compresor"],
  m8TempEvapSalida: row["M8 Temp Evap Salida"],
  m8TempDescarga: row["M8 Temp Descarga"],
  m8PresionSuccion: row["M8 Presión Succión"],
  m8PresionDescarga: row["M8 Presión Descarga"],
  m8IDE: row["IDE M8"],
  m9CondicionCompresor: row["M9 Condición Actual del Compresor"],
  m9CargaCompresor: row["M9 % de Carga Compresor"],
  m9TempEvapSalida: row["M9 Temp Evap Salida"],
  m9TempDescarga: row["M9 Temp Descarga"],
  m9PresionSuccion: row["M9 Presión Succión"],
  m9PresionDescarga: row["M9 Presión Descarga"],
  m9IDE: row["IDE M9"],
  m10CondicionCompresor: row["M10 Condición Actual del Compresor"],
  m10CargaCompresor: row["M10 % de Carga Compresor"],
  m10TempEvapSalida: row["M10 Temp Evap Salida"],
  m10TempDescarga: row["M10 Temp Descarga"],
  m10PresionSuccion: row["M10 Presión Succión"],
  m10PresionDescarga: row["M10 Presión Descarga"],
  m10IDE: row["IDE M10"],
});

export const fullServiceCoolingConsultaConfig = {
  title: "Full Service Cooling",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecooling/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "Full Service Cooling",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};